/**
 * Module praticiens — les CLIENTS (dentistes pris individuellement).
 *
 * Vocabulaire fixé par Dove le 2026-08-05 : « Client » désigne le dentiste
 * individuel, « Cabinet » la clinique ou le centre où il exerce. L'étiquette
 * du menu suit ce vocabulaire ; la route reste `/praticiens` parce que
 * `/clients` sert encore à rediriger les anciens liens vers les cabinets —
 * la réattribuer maintenant enverrait ces liens sur le mauvais objet.
 *
 * Bible §5.5 (liste) + §5.7 (fiche 360).
 * Le grain praticien×cabinet est distinct : l'activité dans un cabinet ne
 * masque jamais le silence dans un autre (§3.1, parcours §31 n°2).
 */
import { lazy } from "react";
import type { ModuleDef } from "../../core/module-contract";

const mod: ModuleDef = {
  id: "praticiens",
  label: "Clients",
  icon: "i-users",
  navGroup: "relations",
  navOrder: 20,
  rolesRequis: [],
  routes: [
    { path: "/praticiens", component: lazy(() => import("./routes/ListePraticiens")) },
    { path: "/praticiens/:id", component: lazy(() => import("./routes/FichePraticien360")) },
  ],
};

export default mod;
